var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['section.blogControls'] = (function () {
    'use strict';

    const initialize = (section) => {
        section.addEventListener("focusin", () => {
            section.style.zIndex = "7";
        });

        section.addEventListener("focusout", (event) => {
            if (section.contains(event.relatedTarget)) {
                return;
            }

            section.style.removeProperty("z-index");
        });
    };

    return {
        initialize
    };

})();
